import { THRESHOLD_FOR_KEYWORD_RESEARCH_VALUE } from "app/filters/const";
import { minAbbrNumberFilter, percentageSignFilter } from "app/filters/ngFilters";

import type { IDataRow } from "app/common/keyword-research/keywords-overview/dataRowTypes";

import { EVolumeAndClicksMetric } from "app/common/keyword-research/keywords-overview/volumeAndClicksTypes";

export const VOLUME_AND_NO_CLICKS_ENDPOINT = "widgetApi/MobileTrafficV2/MobileTraffic/SingleMetric";
export const CLICKS_ENDPOINT = "widgetApi/KeywordAnalysisV2/KeywordAnalysisOrganic/DeviceTraffic";
export const voulmeClicksRowsConfig: Omit<IDataRow, "value" | "change">[] = [
    {
        id: EVolumeAndClicksMetric.VOLUME,
        title: "keyword.analysis.overview.page.v2.volume_and_clicks.volume.title",
        tooltip: "keyword.analysis.overview.page.v2.volume_and_clicks.volume.tooltip",
        filter: (value) => minAbbrNumberFilter()(value, THRESHOLD_FOR_KEYWORD_RESEARCH_VALUE),
    },
    {
        id: EVolumeAndClicksMetric.CLICKS,
        title: "keyword.analysis.overview.page.v2.volume_and_clicks.clicks.title",
        tooltip: "keyword.analysis.overview.page.v2.volume_and_clicks.clicks.tooltip",
        filter: (value) => minAbbrNumberFilter()(value, THRESHOLD_FOR_KEYWORD_RESEARCH_VALUE),
    },
    {
        id: EVolumeAndClicksMetric.ZERO_CLICKS,
        title: "keyword.analysis.overview.page.v2.volume_and_clicks.zero_clicks.title",
        tooltip: "keyword.analysis.overview.page.v2.volume_and_clicks.zero_clicks.tooltip",
        filter: (value) => percentageSignFilter()(value, 0),
        displayNoData: true,
    },
];
